import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-launch-field-help-text',
  templateUrl: './launch-field-help-text.component.html',
  styleUrls: ['./launch-field-help-text.component.scss']
})
export class LaunchFieldHelpTextComponent implements OnInit {
  @Input() helpText: string;

  constructor() { }

  ngOnInit() {}

}
